export default function filterByDateRangeAndProducts(data, dateRange = [], products = []) {
    // Extract startDate and endDate from the dateRange array
    const startDateStr = dateRange[0] || null;
    const endDateStr = dateRange[1] || null;
  
    // Convert input date strings to Date objects if provided
    const startDate = startDateStr ? new Date(startDateStr) : null;
    const endDate = endDateStr ? new Date(endDateStr) : null;
  
    // Ensure endDate is inclusive by setting time to end of the day if provided
    if (endDate) {
      endDate.setHours(23, 59, 59, 999);
    }
  
    // Filter data based on the date range and products array
    return data.filter(item => {
      const transactionDate = new Date(item.transaction_date);
  
      const dateCondition = (
        (!startDate || transactionDate >= startDate) &&
        (!endDate || transactionDate <= endDate)
      );
  
      const productCondition = (
        products.length === 0 || products.includes(item.product)
      );
  console.log(productCondition)
      return dateCondition && productCondition;
    });
  }